import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { BucketPref } from "@/lib/analytics/types";

interface BucketToggleProps {
  value: BucketPref;
  onChange: (v: BucketPref) => void;
}

const OPTIONS: { value: BucketPref; label: string }[] = [
  { value: "auto", label: "Auto" },
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

export function BucketToggle({ value, onChange }: BucketToggleProps) {
  function handleValueChange(raw: string) {
    onChange(raw as BucketPref);
  }

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="bucket-select" className="text-sm select-none whitespace-nowrap">
        Bucket
      </Label>
      <Select value={value} onValueChange={handleValueChange}>
        <SelectTrigger
          id="bucket-select"
          aria-label="Time bucket"
          className="w-[100px] h-8 text-sm"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
